/**
 * Meta Pixel Event Tracking Utility
 * Pixel ID: 1334304401657953
 */

export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Pre-built events
export const trackLead = (source) => trackEvent('Lead', { content_name: source, content_category: 'calculator' });
export const trackRegistration = () => trackEvent('CompleteRegistration', { content_name: 'astrowins_signup' });
export const trackPurchase = (value, currency = 'INR', planName = '') => trackEvent('Purchase', { value, currency, content_name: planName });
export const trackAddToCart = (planName, value) => trackEvent('AddToCart', { content_name: planName, value, currency: 'INR' });
export const trackViewContent = (contentName) => trackEvent('ViewContent', { content_name: contentName });
